import { useValidationContext } from "@features/mx/validations/context";
import { useSearchParams } from "react-router-dom";
import PendingReadingList from "./PendingReadingList";
import { useEffect } from "react";
import ValidationDetailsView from "../../shared/ValidationDetailsView";
function PendingReadingLanding() {

  const { viewMode, readingId, validatorId } = useValidationContext();
  return viewMode === "detail" ? (
    <ValidationDetailsView readingId={readingId} />
  ) : (
    <PendingReadingList />
  );
}

export default PendingReadingLanding;
